module.exports = __webpack_public_path__ + "static/media/beer.af452f10.png";